module.exports = __webpack_public_path__ + "img/fh_code_1.379f27ae.png";